/**
 * HLOS-323: instala todas as bridges iOS-specific no Pyodide.
 *
 * - Apple LLM runtime (apple_llm_runtime) — para Foundation Models
 * - Vision bridge (vision_bridge) — para análise de imagem
 * - Apple TTS é exposto apenas no TS (não é chamado pelo Python)
 *
 * Chame após `initPyodide()`. Idempotente.
 */
import type { PyodideLike } from "../pyodide";
import { injectAppleLLMRuntime } from "./apple_llm_bridge";
import { visionBridge } from "./vision_bridge";

export function injectAppleBridges(pyodide: PyodideLike): {
  llm: boolean;
  vision: boolean;
} {
  const llm = injectAppleLLMRuntime(pyodide);
  const vision = visionBridge.install()
    ? visionBridge.injectIntoPyodide(pyodide)
    : false;
  return { llm, vision };
}
